import { render, staticRenderFns } from "./BoardSettings.vue?vue&type=template&id=8b0ed048&scoped=true"
import script from "./BoardSettings.vue?vue&type=script&lang=js"
export * from "./BoardSettings.vue?vue&type=script&lang=js"
import style0 from "./BoardSettings.vue?vue&type=style&index=0&id=8b0ed048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0ed048",
  null
  
)

export default component.exports